import { Button, View } from 'reshaped'
import { FarcasterIcon, LensIcon, TelegramIcon, XIcon } from './SocialIcons'

interface SocialShareButtonsProps {
  message: string
  shareUrl: string
}

export function SocialShareButtons({ message, shareUrl }: SocialShareButtonsProps) {
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    message
  )}&url=${encodeURIComponent(shareUrl)}`
  const farcasterUrl = `https://farcaster.xyz/~/compose?text=${encodeURIComponent(
    message
  )}&embeds[]=${encodeURIComponent(shareUrl)}`
  const lensUrl = `https://lenster.xyz/?text=${encodeURIComponent(
    message
  )}&url=${encodeURIComponent(shareUrl)}`
  const telegramUrl = `https://t.me/share/url?text=${encodeURIComponent(
    message
  )}&url=${encodeURIComponent(shareUrl)}`

  return (
    <View gap={{ s: 2, m: 3 }} direction="row" justify="start">
      <a
        href={twitterUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          rounded
          icon={XIcon}
          attributes={{
            'aria-label': 'X share icon',
            style: {
              backgroundColor: '#000',
            },
          }}
          size="large"
        />
      </a>

      <a
        href={farcasterUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          rounded
          icon={FarcasterIcon}
          attributes={{
            'aria-label': 'Farcaster share icon',
            style: {
              backgroundColor: '#9c6bff',
            },
          }}
          size="large"
        />
      </a>

      <a
        href={lensUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          rounded
          icon={LensIcon}
          attributes={{
            'aria-label': 'Lens share icon',
            style: {
              backgroundColor: '#3A5845',
            },
          }}
          size="large"
        />
      </a>

      <a
        href={telegramUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          rounded
          icon={TelegramIcon}
          attributes={{
            'aria-label': 'Telegram share icon',
            style: {
              backgroundColor: '#27A7E7',
            },
          }}
          size="large"
        />
      </a>
    </View>
  )
}
